var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0417 0.166664H2.95837C2.32848 0.166664 1.72439 0.416887 1.279 0.862285C0.833597 1.30768 0.583374 1.91177 0.583374 2.54166V10.4583C0.583374 11.0882 0.833597 11.6923 1.279 12.1377C1.72439 12.5831 2.32848 12.8333 2.95837 12.8333H14.0417C14.6716 12.8333 15.2757 12.5831 15.7211 12.1377C16.1665 11.6923 16.4167 11.0882 16.4167 10.4583V2.54166C16.4167 1.91177 16.1665 1.30768 15.7211 0.862285C15.2757 0.416887 14.6716 0.166664 14.0417 0.166664ZM2.95837 1.75H14.0417C14.2517 1.75 14.453 1.8334 14.6015 1.98187C14.75 2.13034 14.8334 2.3317 14.8334 2.54166L8.50004 6.405L2.16671 2.54166C2.16671 2.3317 2.25011 2.13034 2.39858 1.98187C2.54705 1.8334 2.74841 1.75 2.95837 1.75ZM14.8334 10.4583C14.8334 10.6683 14.75 10.8697 14.6015 11.0181C14.453 11.1666 14.2517 11.25 14.0417 11.25H2.95837C2.74841 11.25 2.54705 11.1666 2.39858 11.0181C2.25011 10.8697 2.16671 10.6683 2.16671 10.4583V4.34666L8.08837 7.96458C8.20872 8.03406 8.34524 8.07064 8.48421 8.07064C8.62317 8.07064 8.75969 8.03406 8.88004 7.96458L14.8334 4.34666V10.4583Z",
    fill: "#9FA8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.925c2583761749ecc1767ef8f5f3c1ef.svg";
export { ForwardRef as ReactComponent };